import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import Logo from "../../../assets/images/LAWNET LOGO.png";
import { FaUser } from "react-icons/fa6";
import { IoMdLock } from "react-icons/io";
import { IoMdMail } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import api from "../../../services/baseUrl";
import Cookies from "js-cookie";
export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showSignUp, setShowSignUp] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const user = Cookies.get("wartaUser");
  const [signUpData, setSignUpData] = useState({
    email: "",
    fullName: "",
    username: "",
    password: "",
    confirmPassword: "",
    contactNumber: "",
  });
  const [forgotPasswordData, setForgotPasswordData] = useState({
    email: "",
    username: ""
  });

  useEffect(() => {
    if (user) {
      if (user.isAdmin) {
        navigate("/eWarta/requests");
      } else {
        navigate("/eWarta/gazetteFinder");
      }
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!username.trim()) newErrors.loginUsername = "Username is required";
    if (!password) newErrors.loginPassword = "Password is required";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    try {
      const res = await api.post("/ewarta/login", {
        username,
        password,
      });

      if (res.data.message === "Login successful") {
        Cookies.set("wartaUser", JSON.stringify(res.data.user), {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });
        if (res.data.user.isAdmin === 1) {
          navigate("/eWarta/requests");
        } else {
          navigate("/eWarta/gazetteFinder");
        }
      }
    } catch (error) {
      alert("Login failed. Please check your credentials.");
    }
  };

  const handleSignUp = async () => {
    const newErrors = {};

    if (!signUpData.email.trim()) newErrors.email = "Email is required";
    if (!signUpData.fullName.trim())
      newErrors.fullName = "Full Name is required";
    if (!signUpData.username.trim())
      newErrors.username = "Username is required";
    if (!signUpData.password) newErrors.password = "Password is required";
    if (!signUpData.confirmPassword)
      newErrors.confirmPassword = "Confirm Password is required";
    else if (signUpData.password !== signUpData.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";

    if (!signUpData.contactNumber)
      newErrors.contactNumber = "Contact number is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      await api.post("/ewarta/register", {
        email: signUpData.email,
        username: signUpData.username,
        password: signUpData.password,
        fullName: signUpData.fullName,
        contactNumber: signUpData.contactNumber,
      });
      alert("Sign up successful! Please log in.");
      setShowSignUp(false);
    } catch (error) {
      alert(
        error.response
          ? error.response.data
          : "Sign up failed. Please try again."
      );
    }
  };

  const handleForgotPassword = async () => {
    const newErrors = {};

    if (!forgotPasswordData.email.trim()) newErrors.email = "Email is required";
    if (!forgotPasswordData.username.trim())
      newErrors.username = "Username is required";
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      await api.post("/ewarta/forgotpassword", {
        email: forgotPasswordData.email,
        username: forgotPasswordData.username
      });
      alert("An email is sent with the password successful! Please check your email to get the password and log in.");
      setShowForgotPassword(false);
    } catch (error) {
      alert(
        error.response
          ? error.response.data.message
          : "Forgotpasword failed. Please try again."
      );
    }
  };

  return (
    <div className="warta-login-body">
      <div className="warta-login-container">
        <div className="warta-login-logo">
          <img
            src={Logo}
            alt="Lawnet Logo"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/");
            }}
          />
        </div>
        <div className="warta-login-form">
          <div className="warta-login-form-header">
            <p>Welcome</p>
            <p>to Gazette on Demand</p>
            <p>
              Access gazettes effortlessly with our feature. Instantly explore,
              purchase, and download with just a few clicks – fast, simple, and
              hassle-free for a truly seamless experience
            </p>
          </div>
          <form onSubmit={handleLogin}>
            <div className="warta-login-form-body">
              <p>User Login</p>
              <div className="warta-login-input">
                <div className="warta-login-input-icon">
                  <FaUser size={25} />
                </div>
                <input
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              {errors.loginUsername && (
                <span className="form-error" style={{ marginLeft: "65px" }}>
                  {errors.loginUsername}
                </span>
              )}
              <div className="warta-login-input">
                <div className="warta-login-input-icon">
                  <IoMdLock size={25} />
                </div>
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              {errors.loginPassword && (
                <span className="form-error" style={{ marginLeft: "65px" }}>
                  {errors.loginPassword}
                </span>
              )}
              <div className="warta-login-form-btn-container">
                <button type="submit">Login</button>
              </div>
              <div className="warta-login-signup-link">
                <p>
                  <span
                    onClick={() => setShowForgotPassword(true)}
                    style={{ color: "#007bff", cursor: "pointer" }}
                  >
                    Forgot Password?
                  </span>
                  </p>
              </div>
              <div className="warta-login-signup-link">
                <p>
                  New here?{" "}
                  <span
                    onClick={() => setShowSignUp(true)}
                    style={{ color: "#007bff", cursor: "pointer" }}
                  >
                    Click here to sign up
                  </span>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>

      {showSignUp && (
        <div className="warta-signup-modal">
          <div className="warta-signup-modal-content">
            <span
              className="close"
              onClick={() => setShowSignUp(false)}
              style={{ float: "right", cursor: "pointer", fontSize: "20px" }}
            >
              &times;
            </span>
            <h2>Sign Up</h2>
            <div className="warta-login-input">
              <div className="warta-login-input-icon">
                <IoMdMail size={25} />
              </div>
              <input
                type="email"
                placeholder="Email"
                value={signUpData.email}
                onChange={(e) =>
                  setSignUpData({ ...signUpData, email: e.target.value })
                }
              />
            </div>
            {errors.email && <span className="form-error">{errors.email}</span>}
            <div className="warta-login-input">
              <div className="warta-login-input-icon">
                <FaUser size={25} />
              </div>
              <input
                type="text"
                placeholder="Full Name"
                value={signUpData.fullName}
                onChange={(e) =>
                  setSignUpData({ ...signUpData, fullName: e.target.value })
                }
              />
            </div>
            {errors.fullName && (
              <span className="form-error">{errors.fullName}</span>
            )}
            <div className="warta-login-input">
              <div className="warta-login-input-icon">
                <FaUser size={25} />
              </div>
              <input
                type="text"
                placeholder="Contact Number"
                value={signUpData.contactNumber}
                onChange={(e) =>
                  setSignUpData({
                    ...signUpData,
                    contactNumber: e.target.value,
                  })
                }
              />
            </div>
            {errors.fullName && (
              <span className="form-error">{errors.contactNumber}</span>
            )}
            <div className="warta-login-input">
              <div className="warta-login-input-icon">
                <FaUser size={25} />
              </div>
              <input
                type="text"
                placeholder="Username"
                value={signUpData.username}
                onChange={(e) =>
                  setSignUpData({ ...signUpData, username: e.target.value })
                }
              />
            </div>
            {errors.username && (
              <span className="form-error">{errors.username}</span>
            )}
            <div className="warta-login-input">
              <div className="warta-login-input-icon">
                <IoMdLock size={25} />
              </div>
              <input
                type="password"
                placeholder="Password"
                value={signUpData.password}
                onChange={(e) =>
                  setSignUpData({ ...signUpData, password: e.target.value })
                }
              />
            </div>
            {errors.password && (
              <span className="form-error">{errors.password}</span>
            )}
            <div className="warta-login-input">
              <div className="warta-login-input-icon">
                <IoMdLock size={25} />
              </div>
              <input
                type="password"
                placeholder="Confirm Password"
                value={signUpData.confirmPassword}
                onChange={(e) =>
                  setSignUpData({
                    ...signUpData,
                    confirmPassword: e.target.value,
                  })
                }
              />
            </div>
            {errors.confirmPassword && (
              <span className="form-error">{errors.confirmPassword}</span>
            )}
            <button onClick={handleSignUp}>Sign Up</button>
          </div>
        </div>
      )}

      {showForgotPassword && (
        <div className="warta-signup-modal">
          <div className="warta-signup-modal-content">
            <span
              className="close"
              onClick={() => setShowForgotPassword(false)}
              style={{ float: "right", cursor: "pointer", fontSize: "20px" }}
            >
              &times;
            </span>
            <h2>Forgot Password</h2>
            <div className="warta-login-input">
              <div className="warta-login-input-icon">
                <IoMdMail size={25} />
              </div>
              <input
                type="email"
                placeholder="Email"
                value={forgotPasswordData.email}
                onChange={(e) =>
                  setForgotPasswordData({ ...forgotPasswordData, email: e.target.value })
                }
              />
            </div>
            {errors.email && <span className="form-error">{errors.email}</span>}
            <div className="warta-login-input">
              <div className="warta-login-input-icon">
                <FaUser size={25} />
              </div>
              <input
                type="text"
                placeholder="Username"
                value={forgotPasswordData.username}
                onChange={(e) =>
                  setForgotPasswordData({ ...forgotPasswordData, username: e.target.value })
                }
              />
            </div>
            {errors.username && (
              <span className="form-error">{errors.username}</span>
            )}
            
            <button onClick={handleForgotPassword}>Submit</button>
          </div>
        </div>
      )}
    </div>
  );
}
